
import './EpisodePaneBack.scss';
export default function EpisodePaneBack(props: {
    seasonTitle: string,
    hasMultipleSeasons: boolean,
    onClick: () => void
}) {
    return (
        <div data-uia="episode-pane-back" className="ltr-vi90o6 thisone" onClick={() => {
            if (props.onClick)
                props.onClick();
        }}>
            <div aria-label={props.seasonTitle} tabIndex={0} className="ltr-2t1w26">
            </div>
            <div className="ltr-12ln5ef">
                {props.hasMultipleSeasons && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="Hawkins-Icon Hawkins-Icon-Standard">
                    <path fillRule="evenodd" clipRule="evenodd" d="M24 11.0001L3.41421 11.0001L8.70711 5.70718L7.29289 4.29297L0.292892 11.293C0.105356 11.4805 0 11.7349 0 12.0001C0 12.2653 0.105356 12.5196 0.292892 12.7072L7.29289 19.7072L8.70711 18.293L3.41421 13.0001H24V11.0001Z" fill="currentColor">
                    </path>
                </svg>}
            </div>
            <h3 className="ltr-r7qpj1" data-uia="selector-episode-header">{props.seasonTitle}</h3>
        </div>
    );
}